import {
  langcodes,
  defaultLangcode
} from "#nuxt-language-negotiation/config";
export function toValidLanguage(language) {
  if (typeof language === "string") {
    if (langcodes.includes(language)) {
      return language;
    }
  }
  return defaultLangcode;
}
